// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import {
  redeem_voucher,
  getMerchantDeals,
  export_PurchaserList
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import loader from "../../../style/loader/loader.scss";
import Dialog from "react-bootstrap-dialog";
import ReactAutocomplete from "react-autocomplete";
import auth from "../../../services/auth";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";

let dataSet1 = [];
const history = createBrowserHistory();

let isLoading = "false",
  headers = [],
  data1 = [],
  userID = "",
  csvData=[];
class DealBuyerList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      dealID: "",
      deallist: [],
      dealIDs: [],
      show: false,
      alertMessage: "",
      voucherData: "",
      voucher: "",
      filename: "",
      exportdata: [],
      note: "",
      merchantinfo:"",
      merchantID: "",
      csvData: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";

    userID = this.props.match.params.user_id
      ? this.props.match.params.user_id
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID, {page: 0});
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id, {page: 0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data });
        let merchant=  nextProps.merchantdealList.merchantInfo? nextProps.merchantdealList.merchantInfo:{} ;
        
        this.setState({ merchantname:merchant.legalName, address1: merchant.address1, address2: merchant.address2, city: merchant.city, state: merchant.state, country: merchant.country, zipcode:merchant.zipcode, email:merchant.email, phone:merchant.phone, merchantID: merchant.merchant_id, user_id: merchant.user_id});
      }
    }

    if (this.props.exportList !== nextProps.exportList) {
      if (nextProps.exportList) {
        isLoading = "false";
        this.setState({ exportdata: nextProps.exportList.data });
        this.handleExport(nextProps.exportList.data);
        if(nextProps.exportList.data.length == 0){
          this.props.clearAlert();
          this.setState({
            alertMessage: "Data not available.",
            msgType: "warning",
            show: true
          });
          window.scrollTo(0,0);
        }
      }
    }

    if (this.props.redeemvoucher !== nextProps.redeemvoucher) {
      if (nextProps.redeem_voucher) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.redeemvoucher.message);
        this.state.voucher = "";
        this.state.note = "";

        this.setState({ voucherData: nextProps.redeemvoucher.data });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      isLoading = "false";
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
        this.state.voucher = "";
        this.state.note = "";
      }
    }
  }

  handleExport = data => {
    csvData = [
      [
        "Offer ID",
        "Voucher Number",
        "First Name",
        "Last Name",
        "Email",
        "Phone",
        "Voucher Status",
        "Order Date",
      ]
    ];
    {data &&
      data.map((data, keyIndex) =>
        csvData.push([
          data.OfferID,
          data.VoucherNumber,
          data.FirstName,
          data.LastName,
          data.Email,
          data.Phone,
          data.Status,
          data.OrderDate
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleListChangeOnDeal(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ dealIDs: value });
    this.setState({ disabled: false });
  }

  handleVoucher = () => {
    this.handleDismiss();
    if (!this.state.voucher) {
      this.setState({ voucherError: "red" });
    }else if(!this.state.note){
      this.setState({ noteError: "red" });
    } else {
      this.dialog.show({
        body: "Are you sure you want to redeem this voucher?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.confirmRedeem();
          })
        ]
      });
    }
  };

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.dealIDs.length === 0) {
      isError = true;
      this.setState({ dealIDsError: "red" });
    }

    if (!this.state.filename) {
      isError = true;
      this.setState({ filenameError: "red" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      isLoading = "true";
      const postData = {
        dealID: this.state.dealIDs,
        fileName: this.state.filename
      };
      this.props.export_PurchaserList(postData);
    }
  }

  confirmRedeem() {
    const postdata = {
      voucherNumber: this.state.voucher,
      note: this.state.note,
    };
    this.props.redeem_voucher(postdata);
    isLoading = "true";
    this.handleShow();
  }
  handleClose = () => {
    this.handleDismiss();
    this.state.voucherData = "";
  };

  render() {
    dataSet1 = this.state.exportdata;
    
    let dealListItems = [];
    let dealListData = this.state.deallist ? this.state.deallist : "";
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID}>
          {el.dealText}
        </option>
      ));
    }
    let voucher = this.state.voucherData ? this.state.voucherData : {};
    if (!this.state.voucherData) {
      isLoading = "false";
    }
    this.state.voucherData !== ""
      ? $("#voucherdiv *").prop("visible", true)
      : $("#voucherdiv *").prop("visible", false);

    headers = [
      { label: "Voucher Number", key: "voucherNumber" },
      { label: "Tracking Number", key: "trackingNumber" }
    ];

    data1 = this.state.exportdata;

    return (
      <AnimatedView>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="col-lg-12 add-sub-admin">
          <div className="panel">
           {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-12 add-sub-admin">

          <form onSubmit={this.handleSubmit}>
            <div className="panel">
              <header className="panel-heading">
                Emails for Deal-buyers Report{" "}
              </header>
              <div className="panel-body">
                <div className="col-md-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <FormGroup controlId="formdeallist">
                        <ControlLabel>
                          {" "}
                          Use this to pull purchaser email lists for specific
                          offers. Separate multiple offers by commas.{" "}
                        </ControlLabel>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formdeallist">
                        <ControlLabel> DealIDs </ControlLabel>
                        <FormControl
                          name="dealIDs"
                          componentClass="select"
                          style={{ borderColor: this.state.dealIDsError }}
                          onChange={this.handleListChangeOnDeal.bind(this)}
                          value={this.state.dealIDs}
                          multiple
                        >

                          {dealListItems}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formfilename">
                        <ControlLabel>File name</ControlLabel>

                        <FormControl
                          className="halfWidth"
                          type="text"
                          value={this.state.filename}
                          placeholder="file name"
                          onChange={this.handleChange}
                          name="filename"
                          style={{ borderColor: this.state.filenameError }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="BtnRow">
                    <Col md={12} xs={12}>
                      <Button bsStyle="info" type="submit" id="saveButton">
                        {" "}
                        Submit{" "}
                      </Button>
                      {this.state.csvData ? (
                        <CSVLink
                          data={this.state.csvData}
                          filename={this.state.filename + ".csv"}
                          className="btn btn-default"
                        >
                          Export CSV
                        </CSVLink>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </form>
        </div>
      </AnimatedView>
    );
  }
}

const mapStateToProps = state => ({
  merchantdealList: state.voucherReducer.merchantdealList,
  redeemvoucher: state.voucherReducer.redeemvoucher,
  error: state.voucherReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  exportList: state.voucherReducer.exportList
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    redeem_voucher,
    renderAlert,
    clearAlert,
    getMerchantDeals,
    export_PurchaserList
  })
)(DealBuyerList);



// WEBPACK FOOTER //
// ./src/app/views/merchant/buyerlist/DealBuyerList.js